// extracted by mini-css-extract-plugin
export default {"container":"commentModal_container__3SN1X"};